<template>
  <div class="map-container">
    <!-- Parking List (Left Panel) -->
    <div class="parking-list">
      <!-- Search Bar -->
      <div class="search-bar">
        <input type="text" v-model="searchQuery" placeholder="" />
        <button @click="filterByNameAndAddress" class="search-button"></button>
      </div>

      <!-- Message Section -->
      <div class="message-section">
        畫面顯示 <span class="found-number"> {{ filteredLots.length }}</span> 個停車場
      </div>
      <div class="info-div">

        <!-- ParkingItemsContainer Component -->
        <ParkingItemsContainer :filtered-lots="filteredLots" :selected-lot="selectedLot" @select="selectLot" />
      </div>
    </div>

    <!-- Map Container -->
    <div id="map" :style="{ visibility: isMapReady ? 'visible' : 'hidden' }"></div>
    <!-- <div class="map-crosshair"></div> -->

    <div v-if="!isMapReady" class="spinner-overlay">
      <div class="spinner"></div>
      <div class="spinner-text">正在獲取位置，請開啟定位功能</div>
    </div>

    <div v-if="selectedLot" class="selected-lot-modal">
      <ParkingModal :visible="true" :parking="selectedLot" @close="unSelectLot" @proceed="proceedPayment()" />
    </div>

    <ParkingPaymentModal :visible="isPaymentModalVisible" :parking="selectedLot" @close="isPaymentModalVisible = false"
      @goOnlinePayment="goToOnlinePayment" @cardDiscount="goToCardDiscount" />



  </div>
</template>

<script>
/* global google */
import PullDAO from '@/services/PullDAO';
import { createCustomMarkerIcon, getRemainSpace, logWebClick } from '@/util/util';
import { getUserLocation } from '@/util/map';
import ParkingItemsContainer from '@/components/ParkingItemsContainer.vue';
import ParkingModal from './ParkingModal.vue';
import ParkingPaymentModal from '@/views/parking/ParkingPaymentModal4Map.vue';
import { globalParams } from '@/global';

export default {
  components: {
    ParkingItemsContainer,
    ParkingModal,
    ParkingPaymentModal,
  },
  data() {
    return {
      map: null,
      markers: {}, // Store markers by lot title
      searchQuery: '',
      filteredLots: [],
      selectedLot: null,
      parkingLots: [],
      itemsPerPage: 10000,
      currentPage: 1,
      totalItems: 0,
      parking_filters: {},
      isPaymentModalVisible: false,
      isMapReady: false,
    };
  },
  async mounted() {



    const init_userxLocation = { lat: 25.033964, lng: 121.564468 };

    // Initialize the Google Map
    this.map = new google.maps.Map(document.getElementById('map'), {
      center: init_userxLocation,

      zoom: 14,
      mapTypeId: 'roadmap',
      disableDefaultUI: true,
    });

    // Fetch all parkings on mount


    setTimeout(async () => {
      try {
        console.log("start fetching Parkings after delay at ", new Date().toLocaleTimeString());
        const { latitude, longitude } = await getUserLocation();
        // alert("獲取到用戶位置: " + latitude + ", " + longitude);
        console.log("fetched user location:", latitude, longitude, " at ", new Date().toLocaleTimeString());
        const userxLocation = { lat: latitude, lng: longitude };
        this.map.setCenter(userxLocation);
      } catch (error) {
        console.error("Could not get user location, using default.", error);
      } finally {
        this.isMapReady = true;
      }

      await this.fetchAllParkings(this.currentPage, this.itemsPerPage, this.parking_filters, false);
      this.updateVisibleParkings();


      console.log("Fetching Parkings have been added after delay");
    }, 10);


    // Update visible parkings on zoom or drag
    this.map.addListener('zoom_changed', () => {
      this.updateVisibleParkings();
    });

    this.map.addListener('dragend', () => {
      this.updateVisibleParkings();
    });
  },
  methods: {
    goToCardDiscount() {
      globalParams.selectedParking = this.selectedLot;
      globalParams.prevRoute = '/parking-lots';
      this.$router.push('/OnlinePayment');
    },
    proceedPayment() {
      console.log('Proceeding to payment...');
      this.isPaymentModalVisible = true;
    },

    isMobile() {
      return visualViewport.width < 561;
    },

    // marker 的 title 即為滑鼠停留時的原生提示，僅桌機會出現（手機無 hover）
    markerTooltip(lot) {
      const remain = getRemainSpace(lot);
      if (!remain) return lot.title;
      return lot.title + '\n剩餘車位 ' + remain.displayText;
    },

    unSelectLot() {
      this.selectLot(null);
    },

    async fetchAllParkings(page = this.currentPage, itemsPerPage = this.itemsPerPage, filters = {}, zoomFit = true) {
      const pullDAO = new PullDAO();
      let params = {
        row: itemsPerPage,
        page: page,
        ...filters,
      };

      try {
        const response = await pullDAO.listParkings(params);
        this.parkingLots = response.parkings;
        this.filteredLots = this.parkingLots;

        // Initially show all lots and fit bounds
        this.addMarkers(this.filteredLots);
        if (zoomFit) {
          this.fitBounds(this.filteredLots);
        }
      } catch (error) {
        console.error('Error fetching parkings:', error);
        alert('無法加載停車場資料');
      }
    },

    addMarkers(parkingLots) {
      Object.values(this.markers).forEach(marker => marker.setMap(null));
      this.markers = {};

      parkingLots.forEach((lot) => {
        const isSelected = this.selectedLot && this.selectedLot.title === lot.title;
        createCustomMarkerIcon(lot.title, isSelected, this.isMobile()).then((customIcon) => {
          const marker = new google.maps.Marker({
            position: { lat: parseFloat(lot.latitude), lng: parseFloat(lot.longitude) },
            map: this.map,
            title: this.markerTooltip(lot),
            icon: customIcon,
          });

          marker.lotTitle = lot.title;

          marker.addListener('click', () => {
            this.selectLot(lot, 'marker');
          });

          this.markers[lot.title] = marker;
        }).catch((error) => {
          console.error('Error creating custom marker icon:', error);
        });
      });
    },

    fitBounds(parkingLots) {
      if (parkingLots.length === 0) return;
      const bounds = new google.maps.LatLngBounds();
      // parkingLots.forEach((lot) => {
      //   console.log('lat:', lot.latitude, 'lng:', lot.longitude);
      //   console.log('lat:', parseFloat(lot.latitude), 'lng:', parseFloat(lot.longitude));
      //   // if parseFloat(lot.latitude) && parseFloat(lot.longitude) is not a number, continue 


      //   bounds.extend({ lat: parseFloat(lot.latitude), lng: parseFloat(lot.longitude) });
      // });

      parkingLots.forEach((lot) => {
        const latitude = parseFloat(lot.latitude);
        const longitude = parseFloat(lot.longitude);

        if (isNaN(latitude) || isNaN(longitude)) {
          console.log('Skipping invalid lot:', lot);
          return; // Skip this iteration
        }

        bounds.extend({ lat: latitude, lng: longitude });
      });


      this.map.fitBounds(bounds);
    },

    updateVisibleParkings() {
      const bounds = this.map.getBounds();
      if (!bounds) return;

      const visibleLots = this.parkingLots.filter(lot => {
        const latLng = new google.maps.LatLng(parseFloat(lot.latitude), parseFloat(lot.longitude));
        return bounds.contains(latLng);
      });

      this.filteredLots = visibleLots;
    },

    filterByNameAndAddress() {
      const query = this.searchQuery.trim().toLowerCase();

      if (!query) {
        this.filteredLots = this.parkingLots;
        this.addMarkers(this.filteredLots);
        this.fitBounds(this.filteredLots);
        return;
      }

      const found = this.parkingLots.filter(
        (lot) =>
          lot.title.toLowerCase().includes(query) ||
          lot.address.toLowerCase().includes(query)
      );

      if (found.length === 0) {
        alert('沒有找到符合條件的停車場');
        return;
      }

      this.filteredLots = found;
      this.fitBounds(this.filteredLots);
    },

    selectLot(lot, source) {
      const previouslySelectedLot = this.selectedLot;
      this.selectedLot = lot;

      this.updateMarkerIcons(lot, previouslySelectedLot);

      if (!lot) return;

      // 點擊行為記錄：清單卡片未帶 source（預設 list）、地圖 marker 帶 'marker'
      logWebClick('web_parking_click', lot, { source: source || 'list' });
      if (visualViewport.width < 561) {
        this.zoomToLot([parseFloat(lot.latitude) - 0.007, parseFloat(lot.longitude)]);
        this.map.setZoom(15);
      } else {
        this.map.setCenter({ lat: parseFloat(lot.latitude), lng: parseFloat(lot.longitude) - 0.015 });
        this.map.setZoom(15);
      }
      // this.map.setCenter({ lat: parseFloat(lot.latitude), lng: parseFloat(lot.longitude) - 0.015 });
      // this.map.setZoom(15);
    },

    closeModal() {
      const previouslySelectedLot = this.selectedLot;
      this.selectedLot = null;

      if (previouslySelectedLot) {
        this.updateMarkerIcons(null, previouslySelectedLot);
      }
    },

    updateMarkerIcons(newSelectedLot, oldSelectedLot) {
      if (oldSelectedLot && this.markers[oldSelectedLot.title]) {
        createCustomMarkerIcon(oldSelectedLot.title, false, this.isMobile()).then((icon) => {
          this.markers[oldSelectedLot.title].setIcon(icon);
          this.markers[oldSelectedLot.title].setZIndex(0);
        }).catch((error) => console.error(error));
      }

      if (newSelectedLot && this.markers[newSelectedLot.title]) {
        createCustomMarkerIcon(newSelectedLot.title, true, this.isMobile()).then((icon) => {
          this.markers[newSelectedLot.title].setIcon(icon);
          this.markers[newSelectedLot.title].setZIndex(100);
        }).catch((error) => console.error(error));
      }
    },

    zoomToLot(coords) {
      this.map.setCenter({ lat: coords[0], lng: coords[1] });
      this.map.setZoom(17);
    },
  },
};
</script>

<style scoped>
.map-container {
  width: 100%;
  /* height: 100%; */
  /* flex:1; */
  display: flex;
  position: relative;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.spinner-text {
  margin-top: 20px;
  color: var(--primary-green, #00754a);
  font-weight: bold;
}

.spinner {
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  border: 8px solid var(--gray04);
  border-top: 8px solid var(--primary-green);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

#map {
  
  height: calc(100vh - 80px);
  /* height: 100%; */
  width: 100%;
  position: absolute;
}

/* Crosshair styling */
.map-crosshair {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 32px;
  height: 32px;
  background-image: url('@/assets/plus.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.parking-list {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1000;
  background-color: var(--background-gray);
  border-radius: 16px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 480px;
  height: 520px;
  padding: 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  overflow: hidden;
}

.search-bar {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-start;
  background-color: white;
  flex-shrink: 0;

  flex-direction: row;
  align-items: center;
}

.search-bar input {

  padding: 10px 4px 10px 16px;
  border-radius: 12px;


  width: 90%;
  margin-right: 5px;

  /* border-color:  */
  border: 1px solid var(--gray08);

  /* //styleName: sm/regular; */
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 21.56px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

}

.search-bar button {
  /* padding: 5px 10px; */
  height: 40px;
  width: 40px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: green;
  color: white;
  cursor: pointer;




  background-image: url('@/assets/arrow-right.svg');
  /* Path to your image */
  background-repeat: no-repeat;
  background-position: center;
  /* background-size: contain; Adjust as needed */
  background-size: 24px 24px;
  /* Set the image size to 24x24 */

  text-indent: -9999px;
  /* Hide the button text */


}

.info-div {
  /* flex: 1; */
  overflow-y: auto;
  padding: 0px;
  padding-left: 20px;
}

.message-section {
  margin: 10px 0px;
  padding-left: 20px;

  color: var(--font-gray);
  text-align: left;
  flex-shrink: 0;

  /* //styleName: sm/regular; */
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 21.56px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;



}


.found-number {
  font-weight: 700;
}


.float-button {
  position: fixed;
  top: 120px;
  right: 20px;
  padding: 7px 14px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: white;
  color: var(--primary-green);
  cursor: pointer;
  z-index: 1000;
}

.float-button:hover {
  background-color: #0056b3;
}

.selected-lot-modal {
  position: fixed;
  top: 20px;
  left: 516px;
  background-color: transparent;
  /* border: 2px solid #ccc; */
  /* border-radius: 8px; */
  /* padding: 15px; */
  z-index: 2000;
  /* 需與 .modal-content 同寬（440px）。原本設 250px 靠水平溢出顯示，
     但設定 overflow-y 後 overflow-x 會由 visible 變成 auto，內容右側會被裁掉。 */
  width: 440px;
  /* 高度隨內容增減；超過視窗時可在框內捲動 */
  height: auto;
  max-height: calc(100vh - 40px);
  overflow-y: auto;

  /* transform: scale(0.79, 0.79); */
  transform-origin: top left;
}

.selected-lot-modal h3 {
  margin-top: 0;
}

.selected-lot-modal button {
  margin-top: 10px;
}


@media screen and (max-width: 560px) {

  #map {
    height: calc(100vh - 56px);
    /* width: 100%; */
    /* position: absolute; */
  }

  .parking-list {
    top: 374px;
    left: calc(50% - 187.5px);
    width: 375px;
    height: 438px;
  }

  .search-bar {
    padding: 16px 16px;
  }



  .info-div {
    /* flex: 1; */
    overflow-y: auto;
    padding: 0px;
    padding-left: 16px;
  }

  .message-section {
    padding-left: 16px;


  }

  .selected-lot-modal {
    top: 225px;
    /* bottom: 0px; */
    left: calc(50% - 187.5px);
    width: 375px;
    /* 原本固定 438px 且無捲動，內容超出視窗時看不到也捲不動
       （月票牌價、支付方式、按鈕會被推出畫面） */
    height: auto;
    max-height: calc(100vh - 245px);
    max-height: calc(100dvh - 245px);   /* iOS 需扣掉瀏覽器 UI */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }



}
</style>
